module.exports = __webpack_public_path__ + "images/Incorrect_loop.gif";